import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home-icon/side-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-75f5d6f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-container" }
const _hoisted_2 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "sidebarPopup"
}
const _hoisted_5 = { class: "left-main" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

import {reactive, ref, onMounted, nextTick} from 'vue'
import side1 from '@/assets/home-icon/side1.png'
import side2 from '@/assets/home-icon/side2.png'
import side3 from '@/assets/home-icon/side3.png'
import side4 from '@/assets/home-icon/side4.png'

import side1pick from '@/assets/home-icon/side1-pick.png'
import side2pick from '@/assets/home-icon/side2-pick.png'
import side3pick from '@/assets/home-icon/side3-pick.png'
import side4pick from '@/assets/home-icon/side4-pick.png'

import qrKefu from '@/assets/home-icon/qr-kefu.png'
import qrXiazai from '@/assets/home-icon/qr-xiazai.png'
import qrXiaochengxu from '@/assets/home-icon/qr-xiaochengxu.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'sideBar',
  setup(__props) {

const scrollposition = ref(0)

const images : any = reactive({
    side1,
    side2,
    side3,
    side4,
    side1pick,
    side2pick,
    side3pick,
    side4pick
})
const sideList = reactive([{
    icon: side1,
    text: "",
    qrIcon: qrXiazai,
    title: "",
    qrText: "即刻扫码下载app",
    qrTitle: "",
    bg: ''
},{
    icon: side2,
    text: "",
    qrIcon: qrXiaochengxu,
    qrText: "微信打开小程序试卷资源等你拿",
    qrTitle: "",
    bg: ''
},{
    icon: side3,
    text: "",
    qrIcon: qrKefu,
    qrText: "扫码添加企业微信",
    qrTitle: "在线客服",
    bg: ''
},{
    icon: side4,
    text: "回到顶部",
    qrIcon: "",
    qrText: "",
    qrTitle: "",
    bg: '',
    hide: true
}])
const selected : any = ref(undefined)

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
})

const handleMouseOver = (i: number) => {
    sideList[i].icon = images[`side${i + 1}pick`]
    sideList[i].bg = '#196DFF'
    selected.value = i
}
const handleMouseOut = (i: number) => {
    sideList[i].icon = images[`side${i + 1}`]
    sideList[i].bg = 'white'
    selected.value = undefined
}
const handleClick = (i:number) => {
    if(i === sideList.length - 1) { // 回到顶部
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
}
const handleScroll = () => {
    if(window.scrollY > 0) {
        sideList[sideList.length - 1].hide = false
    }else {
        sideList[sideList.length - 1].hide = true
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sideList, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['item', (i == sideList?.length - 1 && !item?.hide) && 'goTop']),
        style: {marginTop: '16px'},
        key: i,
        onMouseover: ($event: any) => (handleMouseOver(i)),
        onMouseout: ($event: any) => (handleMouseOut(i)),
        onClick: ($event: any) => (handleClick(i))
      }, [
        (!item?.hide)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "content",
              style: _normalizeStyle({background: item.bg || 'white'})
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: ""
              }, null, 8, _hoisted_3)
            ], 4))
          : _createCommentVNode("", true),
        (item.text && !item?.hide)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "text",
              style: _normalizeStyle({color: item?.bg && item?.bg !== 'white' ? item?.bg : '#637183'})
            }, _toDisplayString(item.text), 5))
          : _createCommentVNode("", true),
        (selected.value == i && i != sideList?.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (item.qrTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.qrTitle), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(['qrbox-' + (i + 1), 'qrbox'])
                }, [
                  _createElementVNode("img", {
                    src: item.qrIcon,
                    alt: ""
                  }, null, 8, _hoisted_7)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['txt', 'txt-' + (i + 1)])
                }, _toDisplayString(item.qrText), 3)
              ]),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ], 42, _hoisted_2))
    }), 128))
  ]))
}
}

})